const scrollToElementTop = (element, additionalScroll = 0) => {
    if (!element) {
        return;
    }
    const stickyHeaderElem = document.getElementById('sgStickyHeader');
    let offset = 0;
    if (stickyHeaderElem) {
        offset = stickyHeaderElem.offsetHeight;
    }
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.scrollY - offset + additionalScroll;
    window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
    });
};

const scrollToElementBottom = (element) => {
    element.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'nearest'
    });
};
const scrollToElementById = (id, delay = 0, additionalScroll, focus = false) => {
    setTimeout(() => {
        const element = document.getElementById(id);
        scrollToElementTop(element, additionalScroll);
        if (focus && element) {
            element.focus();
        }
    }, delay);
};

export default {
    scrollToElementById,
    scrollToElementTop,
    scrollToElementBottom
};
